import { useSearchParams } from 'react-router-dom'
import { useGetProvidersUserId } from '@/api/generated/doctor/doctor'
import { LicenseFormPage } from './LicenseFormPage'
import type { LicenseFormValues } from './LicenseFormSchema'
import { useLicenseFormServiceTypes } from './useLicenseFormServiceTypes'
import { useCreateLicense } from '../hooks/useCreateLicense'

export function AddLicensePage() {
  const [searchParams] = useSearchParams()
  const userId = searchParams.get('id') ?? ''
  const createLicense = useCreateLicense(userId)

  const serviceTypes = useLicenseFormServiceTypes()

  // Fetch provider to get existing licenses for duplicate check
  const { data: provider } = useGetProvidersUserId(userId)
  const existingLicenses = provider?.Licenses ?? []

  async function handleSubmit(values: LicenseFormValues) {
    await createLicense.mutateAsync(values)
  }

  return (
    <LicenseFormPage
      mode='add'
      availableServiceTypes={serviceTypes ?? []}
      existingLicenses={existingLicenses}
      successMessage='License added!'
      onSubmit={handleSubmit}
      isPending={createLicense.isPending}
    />
  )
}
